"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "AuthNBanner", {
  enumerable: true,
  get: function () {
    return _AuthNBanner.AuthNBanner;
  }
});
var _AuthNBanner = require("./AuthNBanner");